import React, { useEffect, useState } from "react";
import { imageUrl, baseurl } from "../Baseurl";
import axios from "axios";
import { Link } from "react-router-dom";

const ProductCards = () => {
  const [listings, setListings] = useState([]);
  const [loading, setLoading] = useState(true);
  const selectedCurrency = sessionStorage.getItem("selectedCurrency") || "INR";
  const dollarRate = parseFloat(localStorage.getItem("dollarRate")) || 1;

  useEffect(() => {
    const fetchListings = async () => {
      try {
        const response = await axios.get(`${baseurl}getHomePageListings`);
        const filteredListings =
          response.data?.listings?.filter(
            (item) => item.sale_type === "Hot Sales"
          ) || [];

        const sortedListings = filteredListings
          .sort((a, b) =>
            b.created_at && a.created_at
              ? new Date(b.created_at) - new Date(a.created_at)
              : b.listing_id - a.listing_id
          )
          .slice(0, 8);

        setListings(sortedListings);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching listings:", error);
        setLoading(false);
      }
    };

    fetchListings();
  }, []);

  const convertPrice = (inrPrice) => {
    return selectedCurrency === "USD"
      ? `$${(inrPrice / dollarRate).toFixed(2)}`
      : `₹${inrPrice}`;
  };

  const imageExtensions = [".jpg", ".jpeg", ".png", ".gif", ".webp"];

  const findFirstImage = (images) => {
    return images?.find((img) =>
      imageExtensions.some((ext) => img.toLowerCase().endsWith(ext))
    );
  };

  // Skeleton array for placeholder cards
  const skeletonCards = [...Array(8)];

  return (
    <section className="Hot-sale-section py-5 text-start">
      <img
        src="https://img.freepik.com/premium-vector/science-laboratory-3d-biology-physics-items-tests-experiments-lab-microscope-glass-tubes-vector-realistic-composition_80590-6580.jpg"
        alt="Decorative"
        className="corner-decor-image"
      />

      <div className="hot-sale-container">
        <h2 className="hot-sale-title fw-bold mb-3">Explore Hot Sales</h2>
        <p className="hot-sale-subtitle mb-4">
          Discover trending products at unbeatable prices. Shop now and save
          big!
        </p>

        <div className="row gx-3 gy-4 justify-content-start">
          {loading
            ? skeletonCards.map((_, idx) => (
                <div
                  className="col-6 col-sm-6 col-md-4 col-lg-3 px-2"
                  key={idx}
                >
                  <div className="hot-sale-card text-center border rounded h-100 p-3 d-flex flex-column justify-content-between">
                    <div
                      style={{
                        height: "20px",
                        background: "#e0e0e0",
                        marginBottom: "10px",
                        borderRadius: "4px",
                        animation: "pulse 1.5s infinite",
                      }}
                    ></div>
                    <div
                      style={{
                        height: "150px",
                        background: "#e0e0e0",
                        marginBottom: "10px",
                        borderRadius: "4px",
                        animation: "pulse 1.5s infinite",
                      }}
                    ></div>
                    <div
                      style={{
                        height: "20px",
                        width: "50%",
                        background: "#e0e0e0",
                        marginBottom: "5px",
                        borderRadius: "4px",
                        animation: "pulse 1.5s infinite",
                      }}
                    ></div>
                    <div
                      style={{
                        height: "20px",
                        width: "30%",
                        background: "#e0e0e0",
                        borderRadius: "4px",
                        animation: "pulse 1.5s infinite",
                      }}
                    ></div>
                  </div>
                </div>
              ))
            : listings.map((Listing) => {
                const imageToDisplay =
                  findFirstImage(Listing.images) || "default-image.jpg";

                return (
                  <div
                    className="col-6 col-sm-6 col-md-4 col-lg-3 px-2"
                    key={Listing.listing_id}
                  >
                    <div className="hot-sale-card text-center border rounded  h-100 p-3 d-flex flex-column justify-content-between">
                      <h5 className="text-white">{Listing.title}</h5>
                      <img
                        src={`${imageUrl}listing/${imageToDisplay}`}
                        className="hot-sale-image img-fluid"
                        alt={Listing.title}
                        style={{ height: "150px", objectFit: "contain" }}
                      />
                      <div className="hot-sale-footer d-flex justify-content-between align-items-center mt-auto">
                        <Link
                          to={`/product/${Listing.slug}`}
                          className="text-white"
                        >
                          Shop Now
                        </Link>
                        <span className="arrow-text">→</span>
                      </div>
                    </div>
                  </div>
                );
              })}
        </div>
      </div>

      {/* Skeleton animation */}
      <style>
        {`
          @keyframes pulse {
            0% { opacity: 0.3; }
            50% { opacity: 0.7; }
            100% { opacity: 0.3; }
          }
        `}
      </style>
    </section>
  );
};

export default ProductCards;
